import api from '../api';

export const notificationService = {
    getInitialNotifications: async () => {
        try {
            const response = await api.get(`/notifications/initial`);
            return response.data;
        } catch (error) {
            console.error('Error fetching teachers quizzes:', error);
            throw error;
        }
    },
    getUnreadNotifications: async () => {
        try {
            console.log('getting notifications');
            const response = await api.get(`/notifications/unread`);
            console.log('notifications', response.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching teachers quizzes:', error);
            throw error;
        }
    },
    getHistory: async () => {
        try {
            const response = await api.get(`/notifications/history`);
            return response.data;
        } catch (error) {
            console.error('Error fetching teachers quizzes:', error);
            throw error;
        }
    }
}